import React from "react";
import style from "./ScoreCard.module.scss";
import ProgressBar from "@ramonak/react-progress-bar";
import useCommonStore from "../../../../stores/common";

function ScoreCard() {
  const expandDetails = useCommonStore((state) => state.expandDetails);

  return (
    <div
      className={`${style.cb_score_card} ${expandDetails ? style.expanded : ""}`}
    >
      <div className={style.header}>
        <h5>CB Scorecard</h5>
      </div>

      <div className={style.score_list}>
        <div className={style.score_item}>
          <div className={style.title_amount}>
            <span>New</span>
            <span>$ 309.00</span>
          </div>
          <div className={style.progress_container}>
            <ProgressBar
              completed={50}
              bgColor="#4C70EF"
              height="7px"
              isLabelVisible={false}
              baseBgColor="#4c70ef33"
              labelColor="#"
            />
          </div>
          <div className={style.stats}>
            <span>45% of all chargebacks</span>
            <span>128 chargebacks</span>
          </div>
        </div>

        <div className={style.score_item}>
          <div className={style.title_amount}>
            <span>Pending</span>
            <span>$ 183.00</span>
          </div>
          <div className={style.progress_container}>
            <ProgressBar
              completed={45}
              bgColor="#254FE2"
              height="7px"
              isLabelVisible={false}
              baseBgColor="#254FE233"
              labelColor="#"
            />
          </div>
          <div className={style.stats}>
            <span>45% of all chargebacks</span>
            <span>8 chargebacks</span>
          </div>
        </div>

        <div className={style.score_item}>
          <div className={style.title_amount}>
            <span>Won</span>
            <span>$ 309.00</span>
          </div>
          <div className={style.progress_container}>
            <ProgressBar
              completed={33}
              bgColor="#37B450"
              height="7px"
              isLabelVisible={false}
              baseBgColor="#37B45033"
              labelColor="#"
            />
          </div>
          <div className={style.stats}>
            <span>45% of all chargebacks</span>
            <span>128 chargebacks</span>
          </div>
        </div>

        <div className={style.score_item}>
          <div className={style.title_amount}>
            <span>Loss</span>
            <span>$ 309.00</span>
          </div>
          <div className={style.progress_container}>
            <ProgressBar
              completed={5}
              bgColor="#E03B24"
              height="7px"
              isLabelVisible={false}
              baseBgColor="#E03B2433"
              labelColor="#"
            />
          </div>
          <div className={style.stats}>
            <span>5% of all chargebacks</span>
            <span>128 chargebacks</span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ScoreCard;
